import MinioImg from "public/marketplace-apps/minio.svg";
import MariaDbImg from "public/marketplace-apps/mariaDbLogo.png";
import KeycloakImg from "public/marketplace-apps/Keycloak_Logo.png";
import KafkaImg from "public/marketplace-apps/kafka.png";
import NginxIngressImg from "public/marketplace-apps/nginx-ingress.png";
import GrafanaImg from "public/marketplace-apps/grafana.png";
import GitLabRunnerImg from "public/marketplace-apps/gitLabRunner.svg";
import FerretDbImg from "public/marketplace-apps/ferretDb.webp";
import CertManagerImg from "public/marketplace-apps/certManager.webp";
import ApacheImg from "public/marketplace-apps/apache.png";
import MongoDbImg from "public/marketplace-apps/mongoDb.svg";
import MySqlImg from "public/marketplace-apps/MySql.png";
import PostgresImg from "public/marketplace-apps/Postgresql_elephant.png";
import RabbitmqImg from "public/marketplace-apps/rabbitmq.svg";
import RedisImg from "public/marketplace-apps/redis.svg";
import WordPressImg from "public/marketplace-apps/wordpress-blue-logo-svg-vector.svg";

export const APPS_CONSTANTS = {
  apps: [
    {
      name: "MongoDB",
      slug: "mongodb",
      description: "Popular NoSQL database known for its flexibility and scalability.",
      image: MongoDbImg,
    },
    {
      name: "Apache HTTP Server",
      slug: "apache",
      description:
        "Open-source web server software that powers a significant portion of the web.",
      image: ApacheImg,
    },
    {
      name: "Cert Manager",
      slug: "certManager",
      description:
        "Kubernetes add-on to automate the management and issuance of TLS certificates.",
      image: CertManagerImg,
    },
    {
      name: "FerretDB",
      slug: "ferretdb",
      description: "Open-source MongoDB alternative that uses PostgreSQL as a backend.",
      image: FerretDbImg,
    },
    {
      name: "GitLab Runner",
      slug: "gitlabRunner",
      description: "Open-source tool for running CI/CD jobs in GitLab pipelines.",
      image: GitLabRunnerImg,
    },
    {
      name: "Grafana",
      slug: "grafana",
      description:
        "Open-source analytics and monitoring platform for visualizing metrics.",
      image: GrafanaImg,
    },
    {
      name: "Ingress NGINX",
      slug: "nginxIngress",
      description: "Ingress controller for managing external access to services.",
      image: NginxIngressImg,
    },
    {
      name: "Kafka",
      slug: "kafka",
      description: "Distributed event streaming platform for high-throughput data.",
      image: KafkaImg,
    },
    {
      name: "Keycloak",
      slug: "keycloak",
      description: "Open-source identity and access management solution.",
      image: KeycloakImg,
    },
    {
      name: "MariaDB",
      slug: "mariadb",
      description: "Open-source relational database management system.",
      image: MariaDbImg,
    },
    {
      name: "MinIO",
      slug: "minio",
      description: "High-performance object storage for unstructured data.",
      image: MinioImg,
    },
    {
      name: "MySQL",
      slug: "mysql",
      description: "Widely used open-source relational database management system.",
      image: MySqlImg,
    },
    {
      name: "PostgreSQL",
      slug: "postgresql",
      description:
        "Advanced open-source relational database with strong community support.",
      image: PostgresImg,
    },
    {
      name: "Nginx",
      slug: "nginx",
      description: "High-performance web server and reverse proxy server.",
      image: NginxIngressImg,
    },
    {
      name: "PostgreSQL HA",
      slug: "postgresqlHa",
      description: "High-availability setup for PostgreSQL databases.",
      image: PostgresImg,
    },
    {
      name: "RabbitMQ",
      slug: "rabbitmq",
      description: "Open-source message broker for reliable messaging.",
      image: RabbitmqImg,
    },
    {
      name: "Redis",
      slug: "redis",
      description:
        "In-memory data structure store, used as a database, cache, and message broker.",
      image: RedisImg,
    },
    {
      name: "WordPress",
      slug: "wordpress",
      description: "Popular open-source content management system for building websites.",
      image: WordPressImg,
    },
  ],
  title: "Explore Our Marketplace Apps",
  description:
    "Discover a wide range of applications designed to enhance your OneMind experience. From databases to monitoring tools, authentication services, and deployment utilities — everything you need for a modern cloud-native stack.",
};
